import {flattenConnection, OptionWithValues} from '@shopify/hydrogen';
import {base64Decode} from 'shared/utils/base64';
import {PartialDeep} from 'type-fest';

/**
 * All shopify products have at least 1 variant, even if no variants have been set in Shopify Admin. This seems to be the only way to tell if the product only has its default variant
 */

enum ProductDefaults {
  NAME = 'Title',
  VALUE = 'Default Title',
}

const isProductOptionSingleVariant = (
  // productOptions?: (OptionWithValues | undefined)[],
  productOptions?: (PartialDeep<OptionWithValues> | undefined)[],
) => {
  return (
    productOptions?.length === 1 &&
    productOptions?.[0]?.name === ProductDefaults.NAME &&
    productOptions?.[0]?.values?.[0] === ProductDefaults.VALUE
  );
};

const isSelectedVariantAvailable = (
  variantOptions?: Array<Record<string, any> | undefined>,
  selectedOptions?: Record<string, any>,
) => {
  let available = true;
  if (!variantOptions || !selectedOptions) {
    return false;
  }
  variantOptions.map((option?: Record<string, any>) => {
    const key = option?.name;
    const value = option?.value;
    if (selectedOptions[key] != value) {
      available = false;
    }
  });
  return available;
};

/*
 * Finds the parent product ID in linkpop's productLinks for a given variant/merchandise ID
 */
const getParentProductId = (
  productLinks: Array<any>,
  merchandiseId: string,
) => {
  let parentId = null;
  productLinks.forEach((link) => {
    const productInfo = link.productInfo;
    if (productInfo) {
      const currentParentId = base64Decode(productInfo.id);
      const variants = flattenConnection(productInfo.variants);
      variants.forEach((variant: any) => {
        if (base64Decode(variant.id) === base64Decode(merchandiseId)) {
          parentId = currentParentId;
        }
      });
    }
  });
  return parentId;
};

const getProductFromVariantId = (
  productLinks: Array<any>,
  merchandiseId: string,
) => {
  const parentProductId = base64Decode(
    getParentProductId(productLinks, merchandiseId) || '',
  );
  const productLink = productLinks.find((link) => {
    return base64Decode(link.productInfo?.id) === parentProductId;
  });
  return productLink?.productInfo;
};

export {
  ProductDefaults,
  isProductOptionSingleVariant,
  isSelectedVariantAvailable,
  getParentProductId,
  getProductFromVariantId,
};
